import { useCallback, useEffect, useRef, useState } from 'react';

const SOUND_CONFIG = {
  'card-deal': { src: 'card-deal', volume: 0.4 },
  'ante-coin': { src: 'ante-coin', volume: 0.5 },
  'allin-push-chips': { src: 'allin-push-chips', volume: 0.55 },
  'card-flip': { src: 'card-flip', volume: 0.5 },
  'chip-single': { src: 'chip-single', volume: 0.3 },
  'chip-stack': { src: 'chip-stack', volume: 0.4 },
  'chip-slide': { src: 'chip-slide', volume: 0.5 },
  check: { src: 'check', volume: 0.4 },
  call: { src: 'call', volume: 0.4 },
  raise: { src: 'raise', volume: 0.5 },
  fold: { src: 'fold', volume: 0.3 },
  'all-in': { src: 'all-in', volume: 0.7 },
  win: { src: 'win', volume: 0.6 },
  'winner-game': { src: 'winner-game', volume: 0.62 },
  lose: { src: 'lose', volume: 0.4 },
  'lose-game': { src: 'lose-game', volume: 0.55 },
  'lose-heavy': { src: 'lose-heavy', volume: 0.62 },
  'restart-game-button': { src: 'restart-game-button', volume: 0.45 },
  'your-turn': { src: 'your-turn', volume: 0.5 },
  'timer-start': { src: 'timer-start', volume: 0.45 },
  'timer-tick': { src: 'timer-tick', volume: 0.2 },
  'timer-warning': { src: 'timer-warning', volume: 0.4 },
  'svarka-x8': { src: 'svarka-x8', volume: 0.7 },
  'svarka-x2': { src: 'svarka-x2', volume: 0.64 },
  'svarka-x4': { src: 'svarka-x4', volume: 0.66 },
  'svarka-x8-init': { src: 'svarka-x8-init', volume: 0.69 },
  'svarka-x8-begin': { src: 'svarka-x8-begin', volume: 0.65 },
  'svarka-x8-cancel': { src: 'svarka-x8-cancel', volume: 0.62 },
  'mode-choosen-button': { src: 'mode-choosen-button', volume: 0.65 },
  'button-click': { src: 'button-click', volume: 0.25 },
  'button-hover': { src: 'button-hover', volume: 0.1 },
  notification: { src: 'notification', volume: 0.5 },
  showdown: { src: 'showdown', volume: 0.6 },
  'community-card': { src: 'community-card', volume: 0.45 },
  'belot-shuffle-deal': { src: 'belot-shuffle-deal', volume: 0.42 },
  'belot-card-table': { src: 'belot-card-table', volume: 0.48 },
  'belot-card-table-trump': { src: 'belot-card-table-trump', volume: 0.52 },
  'belot-trick-collect': { src: 'belot-trick-collect', volume: 0.44 },
  'belot-auction-click': { src: 'belot-auction-click', volume: 0.38 },
  'belot-contra-hit': { src: 'belot-contra-hit', volume: 0.58 },
  /** Оверлей итога сессии: накрутка баланса в плюс + финальное «зачисление». */
  'overlay-money-counting': { src: 'overlay-money-counting', volume: 0.42 },
  'overlay-money-balance': { src: 'overlay-money-balance', volume: 0.52 },
  /** Оверлей: завершение накрутки респекта (не кошелёк). */
  'overlay-respect-complete': { src: 'overlay-respect-complete', volume: 0.624 },
  /** То же место, что nishtjak — при крупном выигрыше SEKA (>1000 за сессию). */
  'overlay-respect-complete-big': { src: 'overlay-respect-complete-big', volume: 0.624 },
  /** Оверлей поражения: конец накрутки респекта (вздох). */
  'overlay-respect-defeat': { src: 'overlay-respect-defeat', volume: 0.58 },
};

const EXTERNAL_SOUND_SOURCES = {
  'winner-game': [
    '/winner.mp3',
    '/client/winner.mp3',
    '/public/winner.mp3',
  ],
  'allin-push-chips': [
    '/allinpushchips.mp3',
    '/client/allinpushchips.mp3',
    '/public/allinpushchips.mp3',
  ],
  'lose-heavy': [
    '/udary-hlystom.mp3',
    '/client/udary-hlystom.mp3',
    '/public/udary-hlystom.mp3',
  ],
  'restart-game-button': [
    '/restart-game-button.mp3',
    '/client/restart-game-button.mp3',
    '/public/restart-game-button.mp3',
  ],
  'timer-start': [
    '/zvuk-timer.mp3',
    '/client/zvuk-timer.mp3',
    '/public/zvuk-timer.mp3',
  ],
  'ante-coin': [
    '/ante-coin.mp3',
    '/client/ante-coin.mp3',
    '/public/ante-coin.mp3',
  ],
  check: [
    '/check-button.mp3',
    '/client/check-button.mp3',
    '/public/check-button.mp3',
  ],
  'card-deal': [
    '/zvuk-razdaci-cart.mp3',
    '/client/zvuk-razdaci-cart.mp3',
    '/public/client/zvuk-razdaci-cart.mp3',
  ],
  'svarka-x8': [
    '/svarax8.mp3',
    '/client/svarax8.mp3',
    '/public/svarax8.mp3',
  ],
  'svarka-x2': [
    '/svara-x2.mp3',
    '/client/svara-x2.mp3',
    '/public/svara-x2.mp3',
  ],
  'svarka-x4': [
    '/svara-x4.mp3',
    '/client/svara-x4.mp3',
    '/public/svara-x4.mp3',
  ],
  'svarka-x8-init': [
    '/svara-x8-initialization.mp3',
    '/client/svara-x8-initialization.mp3',
    '/public/svara-x8-initialization.mp3',
  ],
  'svarka-x8-begin': [
    '/svarax8-button-begin.mp3',
    '/client/svarax8-button-begin.mp3',
    '/public/svarax8-button-begin.mp3',
  ],
  'svarka-x8-cancel': [
    '/svarax8-cancel-button.mp3',
    '/client/svarax8-cancel-button.mp3',
    '/public/svarax8-cancel-button.mp3',
  ],
  'mode-choosen-button': [
    '/mode-choosen-button.mp3',
    '/client/mode-choosen-button.mp3',
    '/public/mode-choosen-button.mp3',
  ],
  'community-card': [
    '/zvuk-razdaci-cart.mp3',
    '/client/zvuk-razdaci-cart.mp3',
    '/public/client/zvuk-razdaci-cart.mp3',
  ],
  'overlay-money-counting': [
    '/+money-counting.mp3',
    '/money-counting.mp3',
    '/client/+money-counting.mp3',
    '/client/money-counting.mp3',
    '/public/+money-counting.mp3',
    '/public/money-counting.mp3',
  ],
  'overlay-money-balance': [
    '/money-na-balanse.mp3',
    '/client/money-na-balanse.mp3',
    '/client/public/money-na-balanse.mp3',
    '/public/money-na-balanse.mp3',
  ],
  'overlay-respect-complete': [
    '/nishtjak.mp3',
    '/client/nishtjak.mp3',
    '/client/public/nishtjak.mp3',
    '/public/nishtjak.mp3',
  ],
  'overlay-respect-complete-big': [
    '/ha-ha.mp3',
    '/haha.mp3',
    '/client/ha-ha.mp3',
    '/client/haha.mp3',
    '/client/public/ha-ha.mp3',
    '/client/public/haha.mp3',
    '/public/ha-ha.mp3',
    '/public/haha.mp3',
  ],
  'overlay-respect-defeat': [
    '/vydohnul.mp3',
    '/client/vydohnul.mp3',
    '/client/public/vydohnul.mp3',
    '/public/vydohnul.mp3',
  ],
};

/** HAVE_CURRENT_DATA — достаточно, чтобы чаще успешно стартовал первый play() по сети. */
const MEDIA_READY_MIN = typeof HTMLMediaElement !== 'undefined' ? HTMLMediaElement.HAVE_CURRENT_DATA : 2;

/**
 * Дождаться данных по сети/кэшу перед play(), иначе первый кадр иногда молча падает.
 * При ошибке загрузки — onGiveUp; по таймауту всё равно пробуем onReady (частичный буфер).
 */
function whenMediaCanPlay(audio, { onReady, onGiveUp, timeoutMs = 3200 }) {
  let settled = false;
  let timer = null;
  const done = (fn) => {
    if (settled) return;
    settled = true;
    if (timer != null) clearTimeout(timer);
    try {
      audio.removeEventListener('canplay', onCanPlay);
      audio.removeEventListener('error', onErr);
    } catch {
      /* ignore */
    }
    fn();
  };

  const onCanPlay = () => done(onReady);
  const onErr = () => done(onGiveUp);
  timer = setTimeout(() => done(onReady), timeoutMs);

  if (audio.readyState >= MEDIA_READY_MIN) {
    done(onReady);
    return;
  }

  audio.addEventListener('canplay', onCanPlay, { once: true });
  audio.addEventListener('error', onErr, { once: true });
  try {
    audio.load();
  } catch {
    done(onGiveUp);
  }
}

/** После user gesture «прогревает» цепочку HTMLAudio (политика autoplay). */
const SILENT_WAV_DATA_URL =
  'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAIlYAAESsAAACABAAZGF0YQAAAAA=';

function createSoundGenerator(audioContext) {
  const createOscillatorSound = (
    frequency,
    duration,
    type = 'sine',
    gainStart = 0.3,
    gainEnd = 0
  ) => {
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime);

    gainNode.gain.setValueAtTime(gainStart, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(
      Math.max(gainEnd, 0.001),
      audioContext.currentTime + duration
    );

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.start();
    oscillator.stop(audioContext.currentTime + duration);
  };

  const createNoiseSound = (duration, volume = 0.3) => {
    const bufferSize = audioContext.sampleRate * duration;
    const buffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate);
    const data = buffer.getChannelData(0);

    for (let i = 0; i < bufferSize; i++) {
      data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / bufferSize, 2);
    }

    const source = audioContext.createBufferSource();
    const gainNode = audioContext.createGain();
    const filter = audioContext.createBiquadFilter();

    filter.type = 'highpass';
    filter.frequency.value = 2000;

    source.buffer = buffer;
    gainNode.gain.value = volume;

    source.connect(filter);
    filter.connect(gainNode);
    gainNode.connect(audioContext.destination);

    source.start();
  };

  const createChipSound = (count = 1) => {
    const baseFreq = 3000 + Math.random() * 1000;

    for (let i = 0; i < Math.min(count, 5); i++) {
      setTimeout(() => {
        createNoiseSound(0.05, 0.15);
        createOscillatorSound(baseFreq + i * 200, 0.03, 'sine', 0.1, 0);
      }, i * 30);
    }
  };

  const sounds = {
    'card-deal': (vol = 0.4) => {
      createNoiseSound(0.08, vol * 0.5);
    },

    'ante-coin': (vol = 0.5) => {
      createChipSound(3);
      createOscillatorSound(650, 0.08, 'sine', vol * 0.18, 0);
    },

    'allin-push-chips': (vol = 0.55) => {
      createChipSound(4);
      createNoiseSound(0.08, vol * 0.18);
      setTimeout(() => createChipSound(2), 45);
      setTimeout(() => createOscillatorSound(520, 0.06, 'sine', vol * 0.16, 0), 25);
    },

    'card-flip': (vol = 0.5) => {
      createNoiseSound(0.1, vol * 0.4);
      createOscillatorSound(800, 0.05, 'sine', vol * 0.2, 0);
    },

    'chip-single': () => {
      createChipSound(1);
    },

    'chip-stack': (vol = 0.4) => {
      createChipSound(4);
    },

    'chip-slide': (vol = 0.5) => {
      const duration = 0.3;
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(200, audioContext.currentTime);
      oscillator.frequency.linearRampToValueAtTime(100, audioContext.currentTime + duration);

      gainNode.gain.setValueAtTime(vol * 0.2, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + duration);

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.start();
      oscillator.stop(audioContext.currentTime + duration);

      createNoiseSound(0.15, vol * 0.3);
    },

    check: (vol = 0.4) => {
      createOscillatorSound(600, 0.05, 'sine', vol * 0.3, 0);
      setTimeout(() => {
        createOscillatorSound(800, 0.05, 'sine', vol * 0.3, 0);
      }, 80);
    },

    call: (vol = 0.4) => {
      createChipSound(2);
      createOscillatorSound(500, 0.1, 'sine', vol * 0.2, 0);
    },

    raise: (vol = 0.5) => {
      createOscillatorSound(400, 0.15, 'sine', vol * 0.25, 0);
      setTimeout(() => {
        createOscillatorSound(600, 0.15, 'sine', vol * 0.25, 0);
      }, 100);
      createChipSound(3);
    },

    fold: (vol = 0.3) => {
      createOscillatorSound(300, 0.15, 'sine', vol * 0.2, 0);
      createNoiseSound(0.1, vol * 0.2);
    },

    'all-in': (vol = 0.7) => {
      const playSequence = () => {
        createOscillatorSound(200, 0.1, 'sawtooth', vol * 0.15, 0);
        setTimeout(() => createOscillatorSound(300, 0.1, 'sawtooth', vol * 0.2, 0), 80);
        setTimeout(() => createOscillatorSound(400, 0.15, 'sawtooth', vol * 0.25, 0), 160);
        setTimeout(() => createOscillatorSound(600, 0.3, 'sine', vol * 0.3, 0), 250);
      };
      playSequence();
      createChipSound(5);
    },

    win: (vol = 0.6) => {
      const notes = [523, 659, 784, 1047];
      notes.forEach((freq, i) => {
        setTimeout(() => {
          createOscillatorSound(freq, 0.2, 'sine', vol * 0.3, 0);
        }, i * 120);
      });
      setTimeout(() => createChipSound(5), 400);
    },

    'winner-game': (vol = 0.62) => {
      const notes = [523, 659, 784, 988, 1175];
      notes.forEach((freq, i) => {
        setTimeout(() => {
          createOscillatorSound(freq, 0.12, 'sine', vol * 0.26, 0);
        }, i * 85);
      });
      setTimeout(() => createChipSound(3), 180);
    },

    lose: (vol = 0.4) => {
      createOscillatorSound(300, 0.3, 'sine', vol * 0.2, 0);
      setTimeout(() => {
        createOscillatorSound(200, 0.4, 'sine', vol * 0.15, 0);
      }, 200);
    },

    'lose-game': (vol = 0.55) => {
      createOscillatorSound(260, 0.18, 'sine', vol * 0.25, 0);
      setTimeout(() => createOscillatorSound(220, 0.22, 'sine', vol * 0.23, 0), 130);
      setTimeout(() => createOscillatorSound(180, 0.3, 'triangle', vol * 0.2, 0), 280);
      setTimeout(() => createNoiseSound(0.14, vol * 0.12), 120);
    },

    'lose-heavy': (vol = 0.62) => {
      createNoiseSound(0.09, vol * 0.24);
      createOscillatorSound(140, 0.09, 'sawtooth', vol * 0.3, 0);
      setTimeout(() => createOscillatorSound(120, 0.16, 'triangle', vol * 0.24, 0), 65);
      setTimeout(() => createNoiseSound(0.11, vol * 0.2), 120);
      setTimeout(() => createOscillatorSound(90, 0.22, 'sine', vol * 0.18, 0), 155);
    },

    'restart-game-button': (vol = 0.45) => {
      createOscillatorSound(760, 0.05, 'sine', vol * 0.22, 0);
      setTimeout(() => createOscillatorSound(980, 0.08, 'sine', vol * 0.24, 0), 70);
    },

    'your-turn': (vol = 0.5) => {
      createOscillatorSound(800, 0.1, 'sine', vol * 0.3, 0);
      setTimeout(() => {
        createOscillatorSound(1000, 0.15, 'sine', vol * 0.35, 0);
      }, 120);
    },

    'timer-start': (vol = 0.45) => {
      createOscillatorSound(700, 0.08, 'sine', vol * 0.22, 0);
      setTimeout(() => createOscillatorSound(860, 0.08, 'sine', vol * 0.2, 0), 90);
    },

    'timer-tick': (vol = 0.2) => {
      createOscillatorSound(1000, 0.02, 'sine', vol * 0.2, 0);
    },

    'timer-warning': (vol = 0.4) => {
      createOscillatorSound(800, 0.05, 'square', vol * 0.15, 0);
      setTimeout(() => {
        createOscillatorSound(800, 0.05, 'square', vol * 0.15, 0);
      }, 100);
    },

    'svarka-x2': (vol = 0.64) => {
      createOscillatorSound(520, 0.08, 'sine', vol * 0.22, 0);
      setTimeout(() => createOscillatorSound(720, 0.1, 'sine', vol * 0.24, 0), 70);
      setTimeout(() => createNoiseSound(0.08, vol * 0.12), 60);
    },
    'svarka-x4': (vol = 0.66) => {
      createOscillatorSound(460, 0.07, 'sine', vol * 0.2, 0);
      setTimeout(() => createOscillatorSound(640, 0.08, 'triangle', vol * 0.22, 0), 55);
      setTimeout(() => createOscillatorSound(860, 0.11, 'sine', vol * 0.24, 0), 120);
      setTimeout(() => createNoiseSound(0.09, vol * 0.12), 75);
    },
    'svarka-x8-init': (vol = 0.69) => {
      createOscillatorSound(420, 0.08, 'triangle', vol * 0.22, 0);
      setTimeout(() => createOscillatorSound(580, 0.08, 'sawtooth', vol * 0.24, 0), 55);
      setTimeout(() => createOscillatorSound(760, 0.1, 'sine', vol * 0.26, 0), 120);
      setTimeout(() => createNoiseSound(0.1, vol * 0.14), 85);
    },

    'button-click': (vol = 0.25) => {
      createOscillatorSound(1200, 0.03, 'sine', vol * 0.3, 0);
    },

    'button-hover': (vol = 0.1) => {
      createOscillatorSound(2000, 0.02, 'sine', vol * 0.15, 0);
    },

    notification: (vol = 0.5) => {
      createOscillatorSound(880, 0.1, 'sine', vol * 0.3, 0);
      setTimeout(() => {
        createOscillatorSound(1100, 0.15, 'sine', vol * 0.35, 0);
      }, 100);
    },

    showdown: (vol = 0.6) => {
      createOscillatorSound(200, 0.1, 'sine', vol * 0.2, 0);
      setTimeout(() => createOscillatorSound(400, 0.15, 'sine', vol * 0.25, 0), 150);
      setTimeout(() => createOscillatorSound(600, 0.2, 'sine', vol * 0.3, 0), 300);
    },

    'community-card': (vol = 0.45) => {
      createNoiseSound(0.08, vol * 0.4);
      createOscillatorSound(500, 0.08, 'sine', vol * 0.2, 0);
    },

    /** Rustle + short taps — раздача / тасовка (процедурно). */
    'belot-shuffle-deal': (vol = 0.42) => {
      createNoiseSound(0.12, vol * 0.35);
      setTimeout(() => createNoiseSound(0.08, vol * 0.28), 40);
      setTimeout(() => createOscillatorSound(340, 0.04, 'triangle', vol * 0.12, 0), 90);
      setTimeout(() => createNoiseSound(0.06, vol * 0.22), 130);
    },

    /** Шлёпок карты по столу (не козырь). */
    'belot-card-table': (vol = 0.48) => {
      createNoiseSound(0.045, vol * 0.55);
      createOscillatorSound(620, 0.028, 'sine', vol * 0.22, 0);
    },

    /** Чуть ниже и громче — козырная карта. */
    'belot-card-table-trump': (vol = 0.52) => {
      createNoiseSound(0.05, vol * 0.62);
      createOscillatorSound(420, 0.035, 'triangle', vol * 0.28, 0);
      setTimeout(() => createOscillatorSound(520, 0.02, 'sine', vol * 0.18, 0), 25);
    },

    /** Сбор взятки — скольжение / стопка. */
    'belot-trick-collect': (vol = 0.44) => {
      createNoiseSound(0.14, vol * 0.32);
      setTimeout(() => createChipSound(2), 30);
      setTimeout(() => {
        const duration = 0.22;
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();
        oscillator.type = 'sine';
        oscillator.frequency.setValueAtTime(280, audioContext.currentTime);
        oscillator.frequency.linearRampToValueAtTime(160, audioContext.currentTime + duration);
        gainNode.gain.setValueAtTime(vol * 0.18, audioContext.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + duration);
        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);
        oscillator.start();
        oscillator.stop(audioContext.currentTime + duration);
      }, 60);
    },

    'belot-auction-click': (vol = 0.38) => {
      createOscillatorSound(720, 0.04, 'sine', vol * 0.26, 0);
    },

    'belot-contra-hit': (vol = 0.58) => {
      createNoiseSound(0.06, vol * 0.45);
      createOscillatorSound(180, 0.12, 'square', vol * 0.22, 0);
      setTimeout(() => createOscillatorSound(220, 0.1, 'sawtooth', vol * 0.2, 0), 45);
      setTimeout(() => createOscillatorSound(140, 0.14, 'triangle', vol * 0.18, 0), 95);
    },
  };

  return sounds;
}

export function useGameAudio(options = {}) {
  const { enabled = true, masterVolume = 1 } = options;

  const audioContextRef = useRef(null);
  const soundsRef = useRef(null);
  const externalSoundSrcRef = useRef({});
  const loopPlayersRef = useRef(new Map());
  const loopSeqRef = useRef(0);
  const [isReady, setIsReady] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  /** После первого click / touch / pointerdown / keydown — снимаем типичный autoplay-lock. */
  const [audioUnlocked, setAudioUnlocked] = useState(false);
  const htmlMediaPrimedRef = useRef(false);

  const primeHtmlMediaAfterGesture = useCallback(() => {
    if (htmlMediaPrimedRef.current || typeof Audio === 'undefined') return;
    htmlMediaPrimedRef.current = true;
    try {
      const a = new Audio(SILENT_WAV_DATA_URL);
      a.volume = 0.0001;
      const p = a.play();
      if (p && typeof p.then === 'function') {
        p.then(() => {
          try {
            a.pause();
            a.removeAttribute('src');
            a.load();
          } catch {
            /* ignore */
          }
        }).catch(() => {});
      }
    } catch {
      /* ignore */
    }
  }, []);

  const playExternalSound = useCallback((sound, volume, onFallback) => {
    if (typeof Audio === 'undefined') return false;

    const configured = EXTERNAL_SOUND_SOURCES[sound];
    if (!configured) return false;

    const sources = Array.isArray(configured) ? configured : [configured];
    const preferred = externalSoundSrcRef.current[sound];
    const sourceQueue = preferred ? [preferred, ...sources.filter((src) => src !== preferred)] : sources;

    const tryPlay = (index) => {
      if (index >= sourceQueue.length) {
        onFallback?.();
        return;
      }

      const src = sourceQueue[index];
      const audio = new Audio(src);
      audio.preload = 'auto';
      audio.volume = Math.max(0, Math.min(1, volume));

      const startPlayback = () => {
        const playPromise = audio.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              externalSoundSrcRef.current[sound] = src;
            })
            .catch(() => {
              tryPlay(index + 1);
            });
          return;
        }
        externalSoundSrcRef.current[sound] = src;
      };

      whenMediaCanPlay(audio, {
        onReady: startPlayback,
        onGiveUp: () => tryPlay(index + 1),
        timeoutMs: 2800,
      });
    };

    try {
      tryPlay(0);
      return true;
    } catch {
      onFallback?.();
      return false;
    }
  }, []);

  const initAudio = useCallback(() => {
    const existing = audioContextRef.current;
    if (existing && existing.state !== 'closed') return;

    audioContextRef.current = null;
    soundsRef.current = null;

    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      audioContextRef.current = new AC();
      soundsRef.current = createSoundGenerator(audioContextRef.current);
      setIsReady(true);
    } catch (error) {
      console.error('Failed to initialize audio:', error);
    }
  }, []);

  const play = useCallback(
    (sound, volumeMultiplier = 1) => {
      if (!enabled || isMuted) return;

      if (!audioContextRef.current || audioContextRef.current.state === 'closed') {
        initAudio();
      }

      if (audioContextRef.current?.state === 'suspended') {
        void audioContextRef.current.resume();
      }

      const config = SOUND_CONFIG[sound];
      if (!config) return;
      const volume = config.volume * masterVolume * volumeMultiplier;

      const hasExternal = Boolean(EXTERNAL_SOUND_SOURCES[sound]);
      const proceduralFn = soundsRef.current?.[sound];

      if (!hasExternal && !proceduralFn) return;

      try {
        if (hasExternal) {
          const playedExternal = playExternalSound(sound, volume, () => {
            proceduralFn?.(volume);
          });
          if (!playedExternal && proceduralFn) {
            proceduralFn(volume);
          }
        } else if (proceduralFn) {
          if (!soundsRef.current) return;
          proceduralFn(volume);
        }
      } catch (error) {
        console.error(`Error playing sound ${sound}:`, error);
      }
    },
    [enabled, isMuted, masterVolume, initAudio, playExternalSound]
  );

  const stopLoop = useCallback((loopId) => {
    if (!loopId) return;
    const loopEntry = loopPlayersRef.current.get(loopId);
    if (!loopEntry) return;
    try {
      loopEntry.audio.pause();
      loopEntry.audio.currentTime = 0;
      loopEntry.audio.src = '';
      loopEntry.audio.load();
    } catch {
      /* ignore */
    }
    loopPlayersRef.current.delete(loopId);
  }, []);

  const stopLoopBySound = useCallback((sound) => {
    if (!sound) return;
    const ids = [];
    loopPlayersRef.current.forEach((entry, id) => {
      if (entry.sound === sound) ids.push(id);
    });
    ids.forEach((id) => stopLoop(id));
  }, [stopLoop]);

  const stopAllLoops = useCallback(() => {
    const ids = Array.from(loopPlayersRef.current.keys());
    ids.forEach((id) => stopLoop(id));
  }, [stopLoop]);

  const playLoop = useCallback((sound, volumeMultiplier = 1) => {
    if (!enabled || isMuted) return null;
    if (typeof Audio === 'undefined') return null;

    if (!audioContextRef.current || audioContextRef.current.state === 'closed') {
      initAudio();
    }
    if (audioContextRef.current?.state === 'suspended') {
      void audioContextRef.current.resume();
    }

    const config = SOUND_CONFIG[sound];
    if (!config) return null;

    const configured = EXTERNAL_SOUND_SOURCES[sound];
    const sources = Array.isArray(configured) ? configured : configured ? [configured] : [];
    if (sources.length === 0) return null;

    stopLoopBySound(sound);

    const preferred = externalSoundSrcRef.current[sound];
    const sourceQueue = preferred
      ? [preferred, ...sources.filter((src) => src !== preferred)]
      : sources;
    const volume = Math.max(0, Math.min(1, config.volume * masterVolume * volumeMultiplier));
    const loopId = `${sound}-${Date.now()}-${++loopSeqRef.current}`;

    const tryPlay = (index) => {
      if (index >= sourceQueue.length) {
        loopPlayersRef.current.delete(loopId);
        return;
      }
      const src = sourceQueue[index];
      const audio = new Audio(src);
      audio.preload = 'auto';
      audio.loop = true;
      audio.volume = volume;
      loopPlayersRef.current.set(loopId, { sound, audio });

      const onFail = () => {
        const current = loopPlayersRef.current.get(loopId);
        if (!current || current.audio !== audio) return;
        try {
          audio.pause();
          audio.currentTime = 0;
          audio.src = '';
          audio.load();
        } catch {
          /* ignore */
        }
        loopPlayersRef.current.delete(loopId);
        tryPlay(index + 1);
      };

      const startPlayback = () => {
        try {
          const playPromise = audio.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => {
                externalSoundSrcRef.current[sound] = src;
              })
              .catch(onFail);
            return;
          }
          externalSoundSrcRef.current[sound] = src;
        } catch {
          onFail();
        }
      };

      whenMediaCanPlay(audio, {
        onReady: startPlayback,
        onGiveUp: onFail,
        timeoutMs: 2800,
      });
    };

    tryPlay(0);
    return loopId;
  }, [enabled, isMuted, masterVolume, initAudio, stopLoopBySound]);

  const playSequence = useCallback(
    (list) => {
      list.forEach(({ sound, delay, volume }) => {
        setTimeout(() => play(sound, volume), delay);
      });
    },
    [play]
  );

  const playCardDeal = useCallback(
    (cardCount, delayBetween = 150) => {
      for (let i = 0; i < cardCount; i++) {
        setTimeout(() => play('card-deal'), i * delayBetween);
      }
    },
    [play]
  );

  const playChipBet = useCallback(
    (amount) => {
      if (amount >= 1000) {
        play('chip-stack');
      } else if (amount >= 100) {
        play('chip-stack', 0.7);
      } else {
        play('chip-single');
      }
    },
    [play]
  );

  const toggleMute = useCallback(() => {
    setIsMuted((prev) => !prev);
  }, []);

  useEffect(() => {
    if (!enabled || isMuted) {
      stopAllLoops();
    }
  }, [enabled, isMuted, stopAllLoops]);

  useEffect(() => {
    return () => {
      stopAllLoops();
      const ctx = audioContextRef.current;
      if (ctx && ctx.state !== 'closed') {
        try {
          void ctx.close();
        } catch {
          /* ignore */
        }
      }
      audioContextRef.current = null;
      soundsRef.current = null;
    };
  }, [stopAllLoops]);

  useEffect(() => {
    const handleInteraction = () => {
      initAudio();
      primeHtmlMediaAfterGesture();
      setAudioUnlocked(true);
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
      document.removeEventListener('pointerdown', handleInteraction);
      document.removeEventListener('keydown', handleInteraction);
    };

    document.addEventListener('click', handleInteraction);
    document.addEventListener('touchstart', handleInteraction, { passive: true });
    document.addEventListener('pointerdown', handleInteraction, { passive: true });
    document.addEventListener('keydown', handleInteraction);

    return () => {
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
      document.removeEventListener('pointerdown', handleInteraction);
      document.removeEventListener('keydown', handleInteraction);
    };
  }, [initAudio, primeHtmlMediaAfterGesture]);

  return {
    play,
    playLoop,
    stopLoop,
    stopLoopBySound,
    playSequence,
    playCardDeal,
    playChipBet,
    isReady,
    isMuted,
    audioUnlocked,
    toggleMute,
    initAudio,
  };
}
